import { Box, Button, Card, Container, Stack } from '@mui/material';
import { useMemo } from 'react';
import DataGridCustom from 'src/components/data-grid-custom';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import Iconify from 'src/components/iconify';
import Page from 'src/components/page/page';
import SegmentedTabs from 'src/components/segmented-tabs/segmented-tabs';
import { paths } from 'src/routes/paths';
import { useMyDataStore } from 'src/store/me/me.store';
import EventsDrawerFilters from './components/events-drawer-filters';
import { EventsTableToolbar } from './components/events-table-toolbar';
import ReportsTab from './components/reports-tab';
import useEventsList from './events-list.hook';

export default function EventsList() {
  const {
    eventsList,
    eventsRows,
    eventsColumns,
    isLoadingEventsList,
    currentTab,
    TABS,
    searchText,
    gridSortModel,
    paginationModel,
    selectedRows,
    selectedFiltersCount,
    appliedDraftFilters,
    openFiltersDrawer,
    setSearchText,
    setPaginationModel,
    setSelectedRows,
    handleChangeTab,
    handleSortModelChange,
    handleFilterButtonClick,
    onCloseFilters,
    onApplyFilters,
    handleRowClick,
    navigate,
    exportReport,
  } = useEventsList();
  const permissions = useMyDataStore((state) => state.me?.cnAdminInfo?.permissions?.benefits);

  const renderEventsList = useMemo(
    () => (
      <DataGridCustom
        animatedEachRow
        customFilters={
          <EventsTableToolbar
            searchText={searchText}
            selectedFiltersCount={selectedFiltersCount}
            handleClickFilters={handleFilterButtonClick}
            setSearchText={setSearchText}
          />
        }
        excludeExportButton
        columns={eventsColumns}
        rows={eventsRows}
        totalRowsCount={eventsList.totalFiltered ?? eventsList.total}
        filteredRowsCount={eventsList.totalFiltered ?? eventsList.total}
        initialVisibleColumns={{}}
        sortModel={gridSortModel}
        paginationModel={paginationModel}
        pageSizeOptions={[5, 10, 20, 30, 40, 50]}
        isLoading={isLoadingEventsList}
        onRowClick={handleRowClick}
        setSortModel={handleSortModelChange}
        setPaginationModel={setPaginationModel}
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={setSelectedRows}
        height={550}
      />
    ),
    [
      eventsColumns,
      eventsList.total,
      eventsList.totalFiltered,
      eventsRows,
      gridSortModel,
      handleFilterButtonClick,
      handleRowClick,
      handleSortModelChange,
      isLoadingEventsList,
      paginationModel,
      searchText,
      selectedFiltersCount,
      selectedRows,
      setPaginationModel,
      setSearchText,
      setSelectedRows,
    ]
  );

  return (
    <Page title="Lista de Experiências">
      <Container maxWidth="xl">
        <HeaderBreadcrumbs
          heading="Lista de Experiências"
          links={[]}
          sx={{ mb: 3 }}
          action={
            currentTab === 'events' && (
              <Stack direction="row" spacing={2}>
                <Button
                  size="small"
                  variant="contained"
                  startIcon={<Iconify icon="prime:file-export" sx={{ height: 16, width: 16 }} />}
                  onClick={exportReport}
                  disabled={selectedRows.length === 0}
                >
                  Exportar relatório
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  startIcon={<Iconify icon="mdi:plus" sx={{ height: 16, width: 16 }} />}
                  onClick={() => navigate(paths.dashboard.eventCreate)}
                  disabled={!permissions?.create}
                >
                  Cadastrar Experiência
                </Button>
              </Stack>
            )
          }
        />

        <SegmentedTabs
          ariaLabel="Abas de experiências"
          currentTab={currentTab}
          tabs={TABS}
          onChangeTab={handleChangeTab}
        />

        {currentTab === 'events' ? (
          <Card sx={{ px: 2, pt: 1, pb: 0, boxShadow: 4 }}>
            <Box height="100%">{renderEventsList}</Box>
          </Card>
        ) : (
          <ReportsTab />
        )}
      </Container>

      <EventsDrawerFilters
        isOpen={openFiltersDrawer}
        onClose={onCloseFilters}
        onApplyFilters={onApplyFilters}
        appliedFilters={appliedDraftFilters}
      />
    </Page>
  );
}
